
export  function  geturl() {
    //let baseUrl = "http://localhost:8081"
    let baseUrl = "https://api.lnpine.lol"
    return baseUrl;
}
